export const TASK_TRACKER_DRAWER_DEFAULT_WIDTH = 420
export const TASK_TRACKER_DRAWER_MIN_WIDTH = 420
export const TASK_TRACKER_DRAWER_WIDTH_STORAGE_KEY =
  'task-tracker-crm:task-drawer-width'
export const TASK_TRACKER_DRAWER_ACTIVE_TAB_STORAGE_KEY =
  'task-tracker-crm:task-drawer-active-tab'
/** Ниже @common/Modal (103), чтобы модалки перекрывали панель задачи */
export const TASK_TRACKER_DRAWER_Z_INDEX = 100
